import { alpha, darken } from "@commonlibs";
import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const ButtonStyles = css(
    ({ theme: { spacing, palette, borderRadius, borderRounded } }) => css`
        .Button {
            transition: all 0.1s;
            text-transform: none;
            &:disabled {
                background-color: ${palette.disabled};
                color: ${darken(palette.disabled, 1)};
            }
            &.Loading {
                opacity: 1;
            }
            :active {
                box-shadow: none;
            }
            ${getTypographyStyle("body2Strong")}
            padding: ${spacing.all(3, 4.5)};
            min-height: 3.25rem;
        }

        .Button:not(.Text) {
            border-radius: ${borderRounded};
        }

        //Variant styles
        .Button.Text:not(.Disabled) {
            border-radius: ${borderRadius};
            &:hover {
                background-color: ${alpha(palette.primary, 0.12)};
            }
            &:active {
                background-color: ${alpha(palette.primary, 0.2)};
            }
        }

        .Button.Secondary:not(.Disabled) {
            background-color: ${palette.primary};
            color: ${palette.white};
            &:hover {
                background-color: ${alpha(palette.primary, 0.9)};
            }
            &:active {
                background-color: ${alpha(palette.primary, 0.75)};
            }
        }

        .Button.Primary:not(.Disabled) {
            background-color: ${palette.secondary};
            color: ${palette.primary};
            &:hover {
                background-color: ${alpha(palette.secondary, 0.7)};
            }
            &:active {
                background-color: ${alpha(palette.secondary, 0.4)};
            }
        }

        .Button.Tertiary:not(.Disabled) {
            background-color: ${palette.tertiary};
            color: ${palette.primary};
            &:hover {
                background-color: ${alpha(palette.primary, 0.15)};
            }
            &:active {
                background-color: ${alpha(palette.primary, 0.3)};
            }
        }

        .Button.Danger:not(.Disabled) {
            background-color: ${palette.status.error};
            color: ${palette.white};
            &:hover {
                background-color: ${alpha(palette.status.error, 0.9)};
            }
            &:active {
                background-color: ${alpha(palette.status.error, 0.8)};
            }
        }
    `,
);
